<template>
  <div class="contents_wrapper">
    <div class='contents'>
      <h2 class="large_black_label">ご利用の流れ</h2>
      <UsageMenuBlock />

      <h2 class="large_black_label" id="service">サービス概要</h2>
      <ServiceBlock />
      <BusinessBlock />
      <FeesBlock />
      <AccountBlock />

      <h2 class="large_black_label" id="client">クライアントの発注の流れ</h2>
      <YouTubeBox url="https://www.youtube.com/embed/5NZfY-HNXNA"/>
      <ClientStepOneBlock />
      <ClientStepTwoBlock />
      <ClientStepThreeBlock />
      <ClientStepFourBlock />
      <ClientStepFiveBlock />

      <h2 class="large_black_label" id="operator">オペレーターの受注の流れ</h2>
      <YouTubeBox url="https://www.youtube.com/embed/RbJMtie-A64"/>
      <OperatorStepOneBlock />
      <OperatorStepTwoBlock />
      <OperatorStepThreeBlock />
      <OperatorStepFourBlock />
      <OperatorStepFiveBlock />

      <h2 class="large_black_label" id="score">評価について。</h2>
      <ScoreBlock />

    </div>
  </div>
</template>

<script>
  import YouTubeBox from "@/components/molecules/box/YouTubeBox";

  import UsageMenuBlock from "@/components/objects/block/usage/UsageMenuBlock";
  import ServiceBlock from "@/components/objects/block/usage/ServiceBlock";
  import BusinessBlock from "@/components/objects/block/usage/BusinessBlock";
  import FeesBlock from "@/components/objects/block/usage/FeesBlock";
  import AccountBlock from "@/components/objects/block/usage/AccountBlock";

  import ClientStepOneBlock from "@/components/objects/block/usage/client/ClientStepOneBlock";
  import ClientStepTwoBlock from "@/components/objects/block/usage/client/ClientStepTwoBlock";
  import ClientStepThreeBlock from "@/components/objects/block/usage/client/ClientStepThreeBlock";
  import ClientStepFourBlock from "@/components/objects/block/usage/client/ClientStepFourBlock";
  import ClientStepFiveBlock from "@/components/objects/block/usage/client/ClientStepFiveBlock";

  import OperatorStepOneBlock from "@/components/objects/block/usage/operator/OperatorStepOneBlock";
  import OperatorStepTwoBlock from "@/components/objects/block/usage/operator/OperatorStepTwoBlock";
  import OperatorStepThreeBlock from "@/components/objects/block/usage/operator/OperatorStepThreeBlock";
  import OperatorStepFourBlock from "@/components/objects/block/usage/operator/OperatorStepFourBlock";
  import OperatorStepFiveBlock from "@/components/objects/block/usage/operator/OperatorStepFiveBlock";

  import ScoreBlock from "@/components/objects/block/usage/ScoreBlock";

  export default {
    name: "Usages",

    components: {
      YouTubeBox, AccountBlock, FeesBlock, BusinessBlock, ServiceBlock, UsageMenuBlock,
      ClientStepOneBlock, ClientStepTwoBlock, ClientStepThreeBlock, ClientStepFourBlock, ClientStepFiveBlock,
      OperatorStepOneBlock, OperatorStepTwoBlock, OperatorStepThreeBlock, OperatorStepFourBlock, OperatorStepFiveBlock,
      ScoreBlock},
  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {

    > .contents {
      @include contents();

      > .large_black_label, > .usage-menu_block, > .service_block {
        margin: 2rem 0;
        width: 100%;
      }

      > .service_block, > .business_block, > .fees_block, > .account_block,
      > .client-step-one_block, > .client-step-two_block, > .client-step-three_block, > .client-step-four_block, > .client-step-five_block,
      > .operator-step-one_block, > .operator-step-two_block, > .operator-step-three_block, > .operator-step-four_block, > .operator-step-five_block {
        margin-bottom: 12rem;
      }

      > .youtube_box {
        margin-top: 2rem;
      }

    }

    @media screen and (max-width: 767px) {
      > .contents {
        margin: 0 2.5%;
        width: 95%;
      }
    }
  }
</style>